export const ToyLinksData = [
  {
    title: "High Gloss Study Computer Desk Home Kids",
    image: "https://img.drz.lazcdn.com/static/pk/p/ab0c37f1d6c6df9880b0a1537b123279.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TI25?cc",
  },
  {
    title: "Big Packet Building Blocks Set For Kids Blocks",
    image: "https://img.drz.lazcdn.com/static/pk/p/7f9fec9a2abbfc03ff8df91e6810f2b7.png_720x720q80.png_.webp",
    link: "https://s.daraz.pk/s.0TI0d?cc",
  },
  {
    title: "Kids Wooden Spiral Shapes Stencils Drawing and Puzzle Kit",
    image: "https://img.drz.lazcdn.com/g/kf/S584b760e7bed43ae82535d998eca20ecb.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.03yaK?cc",
  },
  {
    title: "Princess Castle Tent For Girls Fairy Play Tents",
    image: "https://img.drz.lazcdn.com/static/pk/p/1dfcd61fcea430fa6be4d7c4d1f84740.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TIVF?cc",
  },
  {
    title: "EFASHION School Bag for Boys And Girls",
    image: "https://img.drz.lazcdn.com/static/pk/p/d72c226e3f5cd127595553d2daf4452e.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0hSjN?cc",
  },
  {
    title: "5 Design & Multiple Colors School Bag for Boy",
    image: "https://img.drz.lazcdn.com/static/pk/p/2e13b7590a04b9a29c819103c8017001.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0hShW?cc",
  },
  {
    title: "HLNB . Play Group Small size Kids School Bag / 13 inch",
    image: "https://img.drz.lazcdn.com/static/pk/p/c78b4fb995c95069761fd7d303384174.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0hSTh?cc",
  },
  {
    title: "PARAMOUNT 1000 WORDS IN PICTURES BY SHAMA ZAIN",
    image: "https://img.drz.lazcdn.com/g/kf/S1249ac17011f4370b0ac4f3fa4a7ca1an.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0V5zN?cc",
  },
  {
    title: "Fifteen Hole Shape - Baby Toys",
    image: "https://img.drz.lazcdn.com/static/pk/p/d28ca92f166c637e137219688d4c4bff.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QFlP?cc",
  },
  {
    title: "Pack of 15 OFA Colors +6Brush/ 15 OFA Poster",
    image: "https://img.drz.lazcdn.com/static/pk/p/e49b4e35dadbd62cfa389afc1044a0e0.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QLDg?cc",
  },
  {
    title: "Mini Water Dispenser, Mini Cute Duck Drink Water",
    image: "https://img.drz.lazcdn.com/static/pk/p/31eb27731e7fb8d9d96d28f34e8bdbce.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QmXZ?cc",
  },
  {
    title: "6 & 14 in 1 Stationery Gift Set for School Children",
    image: "https://img.drz.lazcdn.com/static/pk/p/0103b607b4e3efbbca0c73a89c5eb8bb.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QmZB?cc",
  },
  {
    title: "Bubble Machine Automatic Electric Gatling Bubble",
    image: "https://img.drz.lazcdn.com/g/kf/Scd59a12da0c443b48d3d471847277497e.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QOz4?cc",
  },
  {
    title: "12 Color Super Light Clay Air Dry Polymer",
    image: "https://img.drz.lazcdn.com/static/pk/p/0b242f3d3b74d97059f8cb41eba26b78.jpg_120x120q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0QOwd?cc",
  },
  {
    title: "White Board+Black Board (large size)20H×24B",
    image: "https://img.drz.lazcdn.com/g/kf/S8cc5dbda6d424cdf9b01c5da8b5b75ca0.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0RvV7?cc",
  },
  {
    title: "Alphabet ABC Words Pin Puzzle - Educational",
    image: "https://img.drz.lazcdn.com/static/pk/p/f595c84cae04a9689e7c5fe896cddf88.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.04woi?cc",
  },
  {
    title: "Soft Plastic Balls for Tent and Pool",
    image: "https://img.drz.lazcdn.com/static/pk/p/4a7a5e1227ddd183fcfff46e4bd775ec.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0h1Qg?cc",
  },
  {
    title: "Level 1 Magical Tracing 64 Pages Work Book",
    image: "https://img.drz.lazcdn.com/static/pk/p/80416bfe7ec961f7a239ded0e1557703.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0fE34",
  },
  {
    title: "12 in 1 Little Learning Library Books for Montessori",
    image: "https://img.drz.lazcdn.com/static/pk/p/68886b6c35dacbd53a5914f86a56c54b.png_720x720q80.png_.webp",
    link: "https://s.daraz.pk/s.0SPS6?cc",
  },
  {
    title: "Wooden Double-Sided Abacus Beads Calculation",
    image: "https://img.drz.lazcdn.com/static/pk/p/273c4a810c4368cfa6b12b21c242817c.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0SGqS?cc",
  },
  {
    title: "A4 75M 100pcs Lamination Pouches A4 75",
    image: "https://img.drz.lazcdn.com/static/pk/p/442da6c0ed4a339368fd0bcb9dc03a7a.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0RhOw?cc",
  },
  {
    title: "12 In 1 Little Learning Library",
    image: "https://img.drz.lazcdn.com/g/kf/S7d880444b91b454485ccda7be374555bR.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.08Uif?cc",
  },
  {
    title: "Learning Flash Cards For Kids - ABC",
    image: "https://img.drz.lazcdn.com/static/pk/p/00f58497449c3dc4da5c0ce3688dc3ea.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.08UQv?cc",
  },
  {
    title: "SMART FLASH CARDS FOOD, FRUITS AND VEGETABLES",
    image: "https://img.drz.lazcdn.com/g/kf/Sbca2ba48b0114b099a46318a0c3632e2E.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.08U8y?cc",
  },
  {
    title: "Personalized Beads Set For Kids 600+ Beads",
    image: "https://img.drz.lazcdn.com/static/pk/p/c9558954d08453486d28c1842cbad038.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0hwe7?cc",
  },
  {
    title: "Wooden Toys Alphabets Recognize Beads",
    image: "https://img.drz.lazcdn.com/static/pk/p/8294d66eb4c5b723a12f834952198a0f.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0hw4U?cc",
  },
  {
    title: "DIY Rainbow Painting Kit, DIY Craft Kit",
    image: "https://img.drz.lazcdn.com/static/pk/p/d76a2ebe308c1522a3a270dcc5d413b3.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.06R2d",
  },
  {
    title: "Tape paper Double Sided Tape For Mounting",
    image: "https://img.drz.lazcdn.com/g/kf/Sa0a81f793d5c49db9fa6d3e900498c32A.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.06FqN?cc",
  },
  {
    title: "Early Learning Toys for kids, Montesori Educational",
    image: "https://img.drz.lazcdn.com/static/pk/p/7960a71f0eac504233c6b5594673c23b.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TIif?cc",
  },
  {
    title: "kids play mat children brain and physical activity",
    image: "https://img.drz.lazcdn.com/static/pk/p/2b4c442d8867d79cd1e7baece222478f.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TIha?cc",
  },
  {
    title: "24-36-42-64 Pes Magnetic Blocks Set Toy",
    image: "https://img.drz.lazcdn.com/g/kf/Sb993de42ce0b4c00808067b810c75c9em.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TIga?cc",
  },
  {
    title: "Kids Children Play Tent Toy Outdoor Foldable",
    image: "https://img.drz.lazcdn.com/static/pk/p/1a1f16e16b65ccc1b6645aa7c340fb2c.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TIUg?cc",
  },
  {
    title: "Colourful High Quality 3D Wooden Puzzle",
    image: "https://img.drz.lazcdn.com/g/kf/Sd88035ebfac349ecab4880800e7a2b38F.jpg_720x720q80.jpg_.webp",
    link: "https://s.daraz.pk/s.0TI3G?cc",
  },
]